import { InjectionToken } from '@angular/core';
import { TokenFacade } from './token.facade';

export const TOKEN_FACADE = new InjectionToken<TokenFacade>('TOKEN_FACADE');